import { createAsyncThunk } from '@reduxjs/toolkit'
import { ANALYTICS_DASHBOARD_GET_POPULAR_CLIL_CATALOG } from '../../prefix-actions.config'
import { getPopularClilCatalogs } from '../../../core/api/services/bookmetrie/get-popular-clil-catalogs.service'

export const popularClilCatalogsAction = createAsyncThunk(
  ANALYTICS_DASHBOARD_GET_POPULAR_CLIL_CATALOG,
  async (): Promise<any> => {
    try {
      const { data } = await getPopularClilCatalogs()
      return data
    } catch (error) {
      throw new Error('Failed to fetch popular clil catalogs...')
    }
  },
)
